import { MasterDataApiService } from 'Services/ApiServices';
import { shouldFetchData } from 'Helpers/ReduxHelper';
import { normalizeApiResponse } from 'Helpers/ApiHelpers';
import F2WCustomLogger from 'Services/F2WCustomLogger';
import { GET_KEYWORDS_SUCCESS } from 'Constants/MasterDataConstants';

export function getKeyWords() {
  const getKeyWordsSuccess = (keywords) => {
    return {
      type: GET_KEYWORDS_SUCCESS,
      data: { keywords },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!shouldFetchData(masterData?.keywords)) return;

    try {
      const response = await MasterDataApiService.getKeywords();
      const { data } = normalizeApiResponse(response);
      dispatch(getKeyWordsSuccess(data || []));
    } catch (error) {
      F2WCustomLogger.error('Error fetching keywords', error, { action: 'getKeyWords' });
      dispatch(getKeyWordsSuccess([]));
    }
  };
}
